"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NxtoQuote = exports.NxtoOrder = exports.Quote = exports.Cart = exports.Order = exports.ORDER_TYPES = exports.EOrderStageColors = void 0;
const Common_1 = require("./Common");
const OrderItem_1 = require("./OrderItem");
const Discount_1 = require("./Discount");
const index_1 = require("../index");
const tz_1 = require("@date-fns/tz");
var EOrderStageColors;
(function (EOrderStageColors) {
    EOrderStageColors["NONE"] = "";
    EOrderStageColors["GREEN"] = "green";
    EOrderStageColors["ORANGE"] = "orange";
    EOrderStageColors["RED"] = "red";
    EOrderStageColors["BLACK"] = "black";
})(EOrderStageColors || (exports.EOrderStageColors = EOrderStageColors = {}));
var ORDER_TYPES;
(function (ORDER_TYPES) {
    ORDER_TYPES[ORDER_TYPES["WEB"] = 1] = "WEB";
    ORDER_TYPES[ORDER_TYPES["PHONE"] = 2] = "PHONE";
    ORDER_TYPES[ORDER_TYPES["SUBSCRIPTION"] = 3] = "SUBSCRIPTION";
})(ORDER_TYPES || (exports.ORDER_TYPES = ORDER_TYPES = {}));
class Order extends index_1.Base {
    invoice_id = '';
    invoice_index = null;
    num_delivered = null;
    num_shipped = null;
    paid = false;
    date_paid = null;
    date_changed = null;
    amount_paid = 0;
    amount_refunded = 0;
    total = null;
    shipping = null;
    subtotal = null;
    total_weight = null;
    expires = null; // quote only?
    locked = null;
    canceled = null;
    source = 0;
    referrer = {}; // fix or deprecate
    quote_id = '';
    replacement = null;
    // If incorrect is set, the values are the order/invoice id of the corrected version of this order.
    incorrect = null;
    // If corrected is set, the values are the order/invoice of the incorrect order being corrected by this one.
    corrected = null;
    url = '';
    contact = null;
    user = null; // This is for the public-facing side, which uses 'user' instead of 'contact'
    items = new index_1.ChildArray();
    payments = new index_1.ChildArray();
    shipments = new index_1.ChildArray();
    refunds = new index_1.ChildArray();
    work = [];
    files = new index_1.ChildArray();
    agents = [];
    followers = [];
    roles = [];
    workers = [];
    metadata = {};
    discount = { amount: 0, code: '' };
    subscription = {};
    stages = {};
    tax = { amount: 0, totalRate: 0, rates: [], total_taxable: 0, exempt: null };
    score = null;
    service_fee = 0;
    address = null;
    items_by_qty;
    selected_rate = null;
    third_party = []; // For storing third-party info/ids.
    _payment_amounts;
    _margin;
    _s = ['items', 'contact', 'invoice_id', 'quote_id', 'stages', 'address', 'total', 'tax', 'discount', 'source', 'locked', 'canceled', 'num_delivered', 'num_shipped', 'replacement', 'subscription'];
    _m = ['name', 'contact', 'type', 'total', 'id', 'invoice_id', 'quote_id'];
    get total_taxable() {
        return (0, Common_1.round)((this.subtotal || 0) + ((typeof this.shipping === 'object') ? 0 : Number(this.shipping || 0)) + ((this.discount) ? Number(this.discount.amount || 0) : 0), 2);
    }
    get balance() {
        let b = (0, Common_1.round)((this.total || 0) - (this.amount_paid || 0) + (this.amount_refunded || 0), 2);
        if (b < 0) {
            b = 0;
        }
        return b;
    }
    get _payment_balance() {
        return (0, Common_1.round)((this.total || 0) - (this._payment_amounts || 0), 2);
    }
    get pieces() {
        let n = 0;
        this.items.forEach(i => n = n + (i.quantity || 0));
        return n;
    }
    constructor(data, olMap, type, idLen) {
        super(type || 'orders', idLen || 26);
        (0, Common_1.setObjectProperties)(this, data, olMap, Order);
        // TODO Remove all this conversion stuff.
        if (this.metadata.replacement) {
            this.replacement = true;
            delete this.metadata.replacement;
        }
        if (this.metadata.corrected_order) {
            this.incorrect = this.metadata.corrected_order;
            delete this.metadata.corrected_order;
        }
        if (this.metadata.linked_order) {
            this.corrected = this.metadata.linked_order;
        }
    }
    validate() {
    }
    toString() {
        return `Order: ${this.invoice_id}: ${this.contact?.name || this['name'] || ''}`;
    }
    setItemsByQty(u) {
        this.items_by_qty = [];
        if (this.items && this.items.length) {
            let total = 1;
            this.items.forEach((item) => {
                let n = 1;
                while (n <= item.quantity) {
                    let piece = new OrderItem_1.OrderItem(JSON.parse(JSON.stringify(item)));
                    piece.quantity = 1;
                    piece.index = total;
                    piece.id = `${item.id}-${n}`;
                    piece.calc(u);
                    this.items_by_qty.push(piece);
                    total++;
                    n++;
                }
            });
        }
    }
    markPaid() {
        if (this.amount_paid < this.total) {
            throw {
                title: 'Cannot Mark Paid',
                message: `The amount paid is not at least as much as the order total.`
            };
        }
        this.paid = true;
    }
    setStage(name, value) {
        this.stages[name] = this.stages[name] || {};
        if (value.agent) {
            this.stages[name].agent = value.agent.toMinJSON ? value.agent?.toMinJSON() : value.agent;
        }
        if (value.color) {
            this.stages[value.color] = Date.now();
        }
        this.stages[name].date = Date.now();
    }
    getStageColor(stage) {
        let r = EOrderStageColors.NONE;
        try {
            r = this.stages[stage].color;
        }
        catch (e) { }
        return r;
    }
    calc(u) {
        this.calcRefunds(u);
        this.calcSubtotal(u);
        this.calcShipping(u);
        this.calcPayments(u);
        this.calcDiscount(u);
        this.calcTax(u);
        this.calcTotals(u);
    }
    calcRefunds(u) {
        let refunds = 0;
        let negative_payments = 0;
        if (this.refunds?.length) {
            refunds = this.refunds?.reduce((n, refund) => {
                n += Number(refund.amount ? Math.abs(refund.amount) : 0);
                return n;
            }, 0);
        }
        if (this.payments?.find(p => p.amount < 0)) {
            negative_payments = this.payments?.reduce((n, refund) => {
                if (refund.amount < 0) {
                    n += Number(refund.amount ? Math.abs(refund.amount) : 0);
                }
                return n;
            }, 0);
        }
        negative_payments = (negative_payments > 0) ? (negative_payments * -1) : negative_payments || 0;
        refunds = (refunds > 0) ? (refunds * -1) : refunds || 0;
        this.amount_refunded = refunds + negative_payments;
    }
    calcSubtotal(u) {
        if (this.items?.length) {
            this.total_weight = 0;
            this.subtotal = (0, Common_1.round)(this.items?.reduce((n, item) => {
                if (item.calc) {
                    item.calc(u);
                    if (item.total_weight) {
                        this.total_weight += item.total_weight;
                    }
                }
                n += (item.subscription?.trial_period_days) ? 0 : item.subtotal;
                return n;
            }, 0), 2);
        }
    }
    calcShipping(u) {
        if (this.shipments?.length) {
            this.shipping = (0, Common_1.round)(this.shipments.reduce((n, item) => {
                n += item.free ? 0 : item.amount;
                return n;
            }, 0), 2);
        }
    }
    calcPayments(u) {
        if (this.payments?.length) {
            this.amount_paid = (0, Common_1.round)(this.payments.reduce((n, payment) => {
                if (Number(payment.amount) > 0 && payment.paid === true) {
                    n += Number(payment.amount);
                }
                return n;
            }, 0), 2);
            this._payment_amounts = (0, Common_1.round)(this.payments.reduce((n, payment) => {
                if (Number(payment.amount) > 0) {
                    n += Number(payment.amount);
                }
                return n;
            }, 0), 2);
        }
        else {
            this._payment_amounts = 0;
        }
    }
    calcTax(u) {
        if (this.tax?.totalRate) {
            if (this.tax.exempt) {
                this.tax.amount = 0;
            }
            else {
                this.tax.amount = (0, Common_1.round)((this.total_taxable || 0) * (this.tax.totalRate || 0), 2);
            }
        }
    }
    calcDiscount(u) {
        if (this.discount && this.discount.type) {
            this.discount = new Discount_1.Discount(this.discount);
            this.discount.calc(this);
            if (!this.discount.amount) {
                this.discount = null;
            }
            else if (this.discount.amount > 0) {
                this.discount.amount = this.discount.amount * -1;
            }
        }
    }
    calcTotals(u) {
        this.total = Number((0, Common_1.round)((this.subtotal || 0)
            + (this.discount?.amount || 0)
            + (this.shipping || 0)
            + (this.tax?.amount || 0), 2));
    }
    toJSON() {
        let r = super.toJSON();
        r.last_date = r.date;
        r.balance = this.balance || 0;
        r.total_taxable = this.total_taxable || 0;
        r.contact_id = this.contact?.id || '';
        return r;
    }
    async clean(c, parent, keep, remove, keepDiscount) {
        await this.loadAll();
        let delProps = ['_docRef', 'id', 'incorrect', 'num_delivered', 'corrected', 'canceled', 'invoice_id', 'date', 'date_paid', 'balance', 'amount_paid', 'pending', 'locked', 'paid', 'quote_id', 'source', 'stages', 'work', 'discount', 'third_party'];
        // When copying quotes to orders, we want to preserve the discount
        // But that must be specified when calling this method.
        if (keepDiscount) {
            delProps.splice(delProps.findIndex(p => p === 'discount'), 1);
        }
        (remove || []).concat(delProps).forEach(p => {
            delete c[p];
        });
        ['supplier_id'].forEach((prop) => {
            delete c.metadata[prop];
        });
        c.locked = false;
        c.canceled = null;
        c.paid = false;
        delete c._docRef;
        c.calc();
        if (parent) {
            await c.save(parent);
        }
        await Promise.all((keep || []).map(async (p) => {
            if (c[p] instanceof Array) {
                await Promise.all(c[p]?.map(async (i, n) => {
                    delete c[p][n]._docRef;
                    delete c[p][n].id;
                    if (parent && c[p][n].save) {
                        await c[p][n].save(c);
                    }
                }));
            }
        }));
        return c;
    }
    async copy(parent) {
        return new Order(await this.clean(new Order(this), parent, ['items'], ['shipments', 'payments']));
    }
    async save(parent) {
        if (this._type === 'quotes') {
            this.quote_id = this.quote_id || (0, Common_1.getInvoiceOrQuoteID)(true, tz_1.TZDate.tz(parent ? parent['timezone'] || 'America/Chicago' : 'America/Chicago'));
        }
        else if (this._type === 'orders') {
            this.invoice_id = this.invoice_id || (0, Common_1.getInvoiceOrQuoteID)(false, tz_1.TZDate.tz(parent ? parent['timezone'] || 'America/Chicago' : 'America/Chicago'));
        }
        if (this.address?.id && !this.address._docRef && parent?._docRef && this.contact?.id) {
            this.address._docRef = parent._docRef.collection('contacts').doc(this.contact.id).collection('addresses').doc(this.address.id);
        }
        await super.save(parent);
    }
}
exports.Order = Order;
index_1.olm.orders = (ref, map) => {
    return new Order(ref, map);
};
class Cart extends Order {
    constructor(data, olMap) {
        super(data, olMap);
        (0, Common_1.setObjectProperties)(this, data, olMap || index_1.olm, Cart);
    }
    async copyToOrder(parent, keep) {
        await this.loadAll();
        return new Order(await super.clean(new Order(this), parent, keep || ['items', 'shipments'], null, true));
    }
}
exports.Cart = Cart;
class Quote extends Order {
    constructor(data, olMap) {
        super(data, olMap, 'quotes', 26);
        (0, Common_1.setObjectProperties)(this, data, olMap, Quote);
    }
    async copy(parent) {
        return new Quote(await super.clean(new Quote(this), parent, ['items', 'shipments'], null, true));
    }
    async copyToOrder(parent, keep) {
        await this.loadAll();
        return new Order(await super.clean(new Order(this), parent, keep || ['items', 'shipments'], null, true));
    }
}
exports.Quote = Quote;
index_1.olm.quotes = (ref, map) => {
    return new Quote(ref, map);
};
class NxtoOrder extends Order {
    client = null;
    constructor(data, olMap, type, idLen) {
        super(data, olMap, type || 'orders', idLen || 31);
        (0, Common_1.setObjectProperties)(this, data, olMap, NxtoOrder);
    }
    validate() {
        if (this.getStageColor('items') !== EOrderStageColors.GREEN) {
            return {
                title: 'Cannot Move Forward',
                message: 'The Items section must be marked as done.',
                path: 'items',
                color: EOrderStageColors.ORANGE
            };
        }
        else {
            switch (this.metadata.type) {
                case index_1.ESubscriptionType.OPS:
                case 'existing_ops':
                case 'new':
                case 'existing':
                    if (!this.client?.name_key) {
                        return {
                            title: 'Cannot Move Forward',
                            message: 'The Client section must at least have the Name Key property set.',
                            path: 'client',
                            color: EOrderStageColors.ORANGE
                        };
                    }
                    break;
                case index_1.ESubscriptionType.GROUP:
                    if (!this.metadata?.access_code || !this.metadata?.member_max) {
                        return {
                            title: 'Cannot Move Forward',
                            message: `The group's access code and max limit must be set.`,
                            path: 'client',
                            color: EOrderStageColors.ORANGE
                        };
                    }
                    break;
            }
        }
    }
    markPaid() {
        let err = this.validate();
        if (err) {
            throw err;
        }
        else {
            super.markPaid();
        }
    }
    toJSON() {
        let r = super.toJSON();
        r.client = this.client?.toJSON ? this.client.toJSON() : this.client;
        return r;
    }
}
exports.NxtoOrder = NxtoOrder;
class NxtoQuote extends NxtoOrder {
    constructor(data, olMap) {
        super(data, olMap, 'quotes', 31);
        (0, Common_1.setObjectProperties)(this, data, olMap, NxtoQuote);
    }
}
exports.NxtoQuote = NxtoQuote;
